import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { resetRunThunk, setRunThunk } from 'state/blotters/scheduledQuotes';
import type { EpicWithThunk } from 'state/state.common';

export function resetRunEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { getRunById } = scheduledRunsApi(httpClient);
    return actions$.pipe(
      ofType('SCHEDULED_RUN_RESET_RUN_REQUESTED'),
      mergeMap(({ runId }) =>
        getRunById(runId).pipe(
          map(run => setRunThunk(run)),
          catchError(() => of(resetRunThunk())),
        ),
      ),
    );
  };
}
